import { render } from "./LoaderError.vue?vue&type=template&id=3e2e35de"
import script from "./LoaderError.vue?vue&type=script&lang=js"
export * from "./LoaderError.vue?vue&type=script&lang=js"

import "./LoaderError.vue?vue&type=style&index=0&id=3e2e35de&lang=scss"
script.render = render

export default script